<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="rounded" :label="$lang.rounded" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="fancy" :label="$lang.fancy" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="vertical" :label="$lang.vertical" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><dropdown :class="['mr-1']" v-model="location" :items="locations" width="128px" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" /><!--
          --><btn tag="a" :href="`${$root.config.staticAssetsDir}/downloads/social-bar-services.js.zip`" :uppercase="false" :class="['mx-1']" size="xs" color="white" :color-lightness="null" :bg-color="$root.$colors.primary" :bg-color-lightness="$root.$colors.bgColorLightness">{{ $lang.downloadSocialServicesJsFile }}</btn>
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <card align="center">
          <card-text style="min-height: 47px">
            <social-bar @share="onShare" :location="location[0]" :rounded="rounded" :fancy="fancy" :services="services" :vertical="vertical" />
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import services from '../../helpers/social-bar-services'
import methods from '../../mixins/methods'

export default {
  name: 'PageSocialBar',
  mixins: [
    methods
  ],
  data () {
    return {
      services,
      rounded: true,
      fancy: false,
      vertical: false,
      location: ['inline'],
      locations: ['inline', 'top', 'right', 'bottom', 'left'].map(value => {
        return {
          value,
          text: this.firstLetterCapital(value)
        }
      })
    }
  },
  watch: {
    location () {
      this.vertical = !['top', 'bottom'].includes(this.location[0])
    },
    fancy () {
      if (this.fancy) {
        this.rounded = false
      }
    },
    rounded () {
      if (this.rounded) {
        this.fancy = false
      }
    }
  },
  methods: {
    onShare ($event) {
      this.log('share', 'social-bar', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/social-bar.vue